/** @deprecated */
export const petriSpecs = {
  CartTooltipWithoutNumber: 'specs.stores.CartTooltipWithoutNumber',
  AddSlotToCartPage: 'specs.stores.AddSlotToCartPage',
  SideCartElementsVisibilityInCss: 'specs.stores.SideCartElementsVisibilityInCss',
  MapCartSummaryColors: 'specs.stores.MapCartSummaryColors',
  DeliverySectionCheckoutUseDeliverySolutions: 'specs.stores.DeliverySectionCheckoutUseDeliverySolutions',
  SideCartEditor3HideSettingsDesignPanel: 'specs.ecom.SideCartEditor3HideSettingsDesignPanel',
  ShowFormsPerLineItemsStep: 'specs.ecom.ShowFormsPerLineItemsStep',
  UseLineItemDiscountInCartSummary: 'specs.ecom.UseLineItemDiscountInCartSummary',
  CheckoutComposerSideCartSettingsPanelEntry: 'specs.ecom.CheckoutComposerSideCartSettingsPanelEntry',
  CheckoutComposerSuccessPopupSettingsPanelEntry: 'specs.ecom.CheckoutComposerSuccessPopupSettingsPanelEntry',
} as const;

export const conductorSpecs = {
  ecomCartLineItemUpsells: 'ecomCartLineItemUpsells',
  ecomShowTotalSavings: 'ecomShowTotalSavings',
  ecomShowReducedDiscountAmount: 'ecomShowReducedDiscountAmount',
  ecomShowEstimateDeliveryOnSubdivisionError: 'ecomShowEstimateDeliveryOnSubdivisionError',
  ecomShowFreeShippingCouponPlacementInCart: 'ecomShowFreeShippingCouponPlacementInCart',
  ecomPlanAndBookInPurchaseFlow: 'ecomPlanAndBookInPurchaseFlow',
  ecomIgnoreCartButtonsTextOpacity: 'ecomIgnoreCartButtonsTextOpacity',
  ecomCartCrossSell: 'ecomCartCrossSell',
  ecomCartCssVars: 'ecomCartCssVars',
  ecomCheckoutComposerBM: 'ecomCheckoutComposerBM',
  ecomRemovePmNameErrorModal: 'ecomRemovePmNameErrorModal',
} as const;

export const SPECS = {
  ...petriSpecs,
  ...conductorSpecs,
} as const;
